// Phone utilities for India-specific mobile validation and normalization

// Returns { e164, national10 } if valid, else throws Error with message
export function normalizeIndianMobile(input) {
  if (!input) throw new Error('Enter your mobile number');
  const trimmed = String(input).trim();
  // Remove spaces, dashes, parentheses
  const digits = trimmed.replace(/[^0-9+]/g, '');

  let national = '';
  if (digits.startsWith('+')) {
    // +91XXXXXXXXXX
    if (!digits.startsWith('+91')) throw new Error('Use Indian numbers only (+91)');
    national = digits.replace('+91', '');
  } else if (digits.startsWith('0')) {
    // 0XXXXXXXXXX
    national = digits.replace(/^0+/, '');
  } else {
    // XXXXXXXXXX
    national = digits;
  }

  // Keep only digits
  national = national.replace(/\D/g, '');

  if (national.length !== 10) throw new Error('Mobile must be 10 digits');
  if (!/^[6-9]/.test(national)) throw new Error('Mobile must start with 6,7,8,9');

  return { e164: `+91${national}`, national10: national };
}

export function isValidIndianMobile(input) {
  try {
    normalizeIndianMobile(input);
    return true;
  } catch {
    return false;
  }
}

export function validationMessage(input) {
  try {
    normalizeIndianMobile(input);
    return '';
  } catch (e) {
    return e.message || 'Invalid mobile number';
  }
}
